import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ClassTechLogo from '../brand/ClassTechLogo';

const PublicFooter: React.FC = () => {
  const { t, i18n } = useTranslation('navigation');
  const isArabic = i18n.language === 'ar';
  return (
    <footer className='bg-sidebar text-white py-12'>
      <div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8'>
        <div className='grid grid-cols-1 md:grid-cols-4 gap-8'>
          <div>
            <div className='mb-4'>
              <ClassTechLogo variant='white' size='sm' showTagline />
            </div>
            <p className='text-gray-400'>
              {isArabic
                ? 'منصة تعليمية وإدارية متكاملة للمدرسين والسناتر والمدارس والأكاديميات.'
                : 'An integrated learning and operations platform for tutors, centers, schools, and academies.'}
            </p>
          </div>

          <div>
            <h3 className='text-lg font-semibold mb-4'>{isArabic ? 'المنتج' : 'Product'}</h3>
            <ul className='space-y-2 text-gray-400'>
              <li>
                <Link
                  to='/features'
                  className='hover:text-white transition-colors'
                >
                  {t('features')}
                </Link>
              </li>
              <li>
                <Link
                  to='/pricing'
                  className='hover:text-white transition-colors'
                >
                  {t('pricing')}
                </Link>
              </li>
              <li>
                <Link
                  to='/documentation'
                  className='hover:text-white transition-colors'
                >
                  {isArabic ? 'التوثيق' : 'Documentation'}
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className='text-lg font-semibold mb-4'>{t('support')}</h3>
            <ul className='space-y-2 text-gray-400'>
              <li>
                <Link
                  to='/support'
                  className='hover:text-white transition-colors'
                >
                  {isArabic ? 'مركز المساعدة' : 'Help center'}
                </Link>
              </li>
              <li>
                <Link
                  to='/contact'
                  className='hover:text-white transition-colors'
                >
                  {isArabic ? 'تواصل معنا' : 'Contact us'}
                </Link>
              </li>
              <li>
                <Link to='/faq' className='hover:text-white transition-colors'>
                  {isArabic ? 'الأسئلة الشائعة' : 'FAQ'}
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className='text-lg font-semibold mb-4'>{isArabic ? 'الشركة' : 'Company'}</h3>
            <ul className='space-y-2 text-gray-400'>
              <li>
                <Link
                  to='/about'
                  className='hover:text-white transition-colors'
                >
                  {t('about')}
                </Link>
              </li>
              <li>
                <Link
                  to='/privacy'
                  className='hover:text-white transition-colors'
                >
                  {isArabic ? 'سياسة الخصوصية' : 'Privacy policy'}
                </Link>
              </li>
              <li>
                <Link
                  to='/terms'
                  className='hover:text-white transition-colors'
                >
                  {isArabic ? 'شروط الاستخدام' : 'Terms of service'}
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className='border-t border-white/10 mt-8 pt-8 text-center text-gray-400'>
          <p>
            &copy; {new Date().getFullYear()} Class Tech.{' '}
            {isArabic ? 'جميع الحقوق محفوظة.' : 'All rights reserved.'}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default PublicFooter;
